import { findAncestorByClass } from '../js-utils/_shared/utils';

export default function init(container: HTMLElement) {
    const headers = container.querySelectorAll('.js-accordion-header') as NodeListOf<HTMLElement>;

    if (headers) {
        headers.forEach((acc) => {
            acc.addEventListener('click', () => {
                let accordion = findAncestorByClass(acc, 'accordion');
                if (accordion) accordion.classList.toggle('opened');
            });
        });
    }
}
